export default "__VITE_ASSET__a2fa3b08__"